// ProgressBar.jsx
import React from "react";

const defaultSteps = [
  "Role information",
  "Set Permissions",
  "Finish",
];

const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12L4.625 10.3333L7.875 13.6667L14.375 7L16 8.66667L7.875 17L3 12Z"
      fill="white"
    />
  </svg>
);

export default function ProgressBar({ step = 1, steps = defaultSteps }) {
  const current = Math.max(1, Math.min(step, steps.length));

  return (
    <nav aria-label="Progress" className="flex flex-col items-start">
      {steps.map((label, index) => {
        const idx = index + 1;
        const completed = current > idx;
        const active = current === idx;
        const isLast = index === steps.length - 1;

        return (
          <div key={label} className="flex items-start w-full">
            {/* LEFT: circle + bar */}
            <div className="flex flex-col items-center mr-3">
              <div
                className={`
                  w-5 h-5 rounded-full flex items-center justify-center
                  ${
                    completed
                      ? "bg-[#157D93] border border-[#157D93] text-white"
                      : active
                      ? "bg-white border-2 border-[#157D93] text-[#157D93]"
                      : "bg-white border border-gray-300 text-gray-400"
                  }
                `}
              >
                {completed ? (
                  <CheckIcon />
                ) : active ? (
                  <span className="w-2.5 h-2.5 rounded-full bg-[#157D93]" />
                ) : (
                  <span className="w-2.5 h-2.5 rounded-full bg-transparent" />
                )}
              </div>

              {!isLast && (
                <div
                  className={`w-px ${completed ? "bg-[#157D93]" : "bg-gray-300"}`}
                  style={{ height: 30 }}
                />
              )}
            </div>

            {/* RIGHT: label */}
            <div className="pb-4 w-full truncate">
              <div
                className={`
                  text-sm font-medium truncate
                  ${completed ? "text-black" : active ? "text-black" : "text-gray-500"}
                `}
              >
                {label}
              </div>
            </div>
          </div>
        );
      })}
    </nav>
  );
}
